import { useRef, useState } from 'react';

import { useActiveOffer } from '@zapier/promotions';

import {
  useCurrencies,
  usePendingPayment,
} from '@zapier/design-system-revenue/src/hooks';

import { usePricingPageSize } from '@zapier/design-system-revenue/src/utils';

export const usePricingPage = () => {
  const { isLoading: isLoadingCurrencies, selectedCurrency } = useCurrencies();

  const {
    activeOffer,
    activeOfferEndDate,
    isLoading: isLoadingActiveOffer,
  } = useActiveOffer();

  const { pendingInvoice } = usePendingPayment();
  const featureListRef = useRef<HTMLElement>();
  const size = usePricingPageSize();

  const [isShowingLegacyPlanModal, setIsShowingLegacyPlanModal] = useState(
    false
  );

  return {
    activeOffer,
    activeOfferEndDate,
    featureListRef,
    isLoading: isLoadingActiveOffer || isLoadingCurrencies,
    isShowingLegacyPlanModal,
    pendingInvoice,
    selectedCurrency,
    setIsShowingLegacyPlanModal,
    size,
  };
};
